import Crud from '../components/CheckRequest/Crud'
import Add from '../components/CheckRequest/Add'

import Approve from '../components/CheckRequest/Approve'

let routes = {
    path: '/checkRequest',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/checkRequests',
            name: 'Solicitações de marcação',
            component: Crud
        },
        {
            path: '/checkRequest/:id?',
            name: 'Solicitação de marcação',
            component: Add
        },
        {
            path: '/checkRequests/approve',
            name: 'Aprovar solicitações de marcação',
            component: Approve
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/checkRequest.js